<template>
  <NavigationHeader :title="wp.title" accent />
</template>

<script>
export default {
  name: 'RegisterHeader',
  inject: ['wp']
}
</script>
